import { batchActions } from 'redux-batched-actions';
import { closeSnackbar, openSnackbar, resumeSnackbar } from './creators';

const dismissNotification = () => (dispatch, getState) => {
	// material design standards state that notifications must be closed before presenting a new one
	const messageCount = getState()
		.notifications.get('messages')
		.count();
	const delay = messageCount > 1 ? 250 : 0;

	dispatch(closeSnackbar());
	return new Promise(resolve =>
		setTimeout(() => {
			if (messageCount > 1) {
				dispatch(batchActions([resumeSnackbar(), openSnackbar()]));
			} else {
				dispatch(resumeSnackbar());
			}
			resolve();
		}, delay),
	);
};

export default dismissNotification;
